import { useState } from 'react';

export default function FloatingGuide() {
  const [open, setOpen] = useState(false);

  const handleScrollContact = (e: React.MouseEvent) => {
    e.preventDefault();
    setOpen(false);
    const el = document.querySelector('#contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handleScrollTop = (e: React.MouseEvent) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="fixed right-5 bottom-24 z-50 flex flex-col items-end gap-3">
      {/* Expanded panel */}
      {open && (
        <div className="flex flex-col items-end gap-2 mb-1">
          {/* Label + Button rows */}
          <div className="flex items-center gap-2">
            <span className="bg-white text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-gray-200 whitespace-nowrap">
              010-6606-5909
            </span>
            <a
              href="tel:01066065909"
              className="w-11 h-11 flex items-center justify-center bg-[#03C75A] rounded-full cursor-pointer hover:bg-[#00A843] transition-colors"
              title="휴대폰 상담"
            >
              <i className="ri-phone-fill text-white text-lg"></i>
            </a>
          </div>
          <div className="flex items-center gap-2">
            <span className="bg-white text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-gray-200 whitespace-nowrap">
              02-704-5909
            </span>
            <a
              href="tel:027045909"
              className="w-11 h-11 flex items-center justify-center bg-[#03C75A] rounded-full cursor-pointer hover:bg-[#00A843] transition-colors"
              title="유선 상담"
            >
              <i className="ri-phone-line text-white text-lg"></i>
            </a>
          </div>
          <div className="flex items-center gap-2">
            <span className="bg-white text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-gray-200 whitespace-nowrap">
              온라인 상담신청
            </span>
            <a
              href="#contact"
              onClick={handleScrollContact}
              className="w-11 h-11 flex items-center justify-center bg-[#03C75A] rounded-full cursor-pointer hover:bg-[#00A843] transition-colors"
              title="온라인 상담"
            >
              <i className="ri-chat-3-line text-white text-lg"></i>
            </a>
          </div>
          <div className="flex items-center gap-2">
            <span className="bg-white text-gray-700 text-xs font-semibold px-3 py-1.5 rounded-full border border-gray-200 whitespace-nowrap">
              맨 위로
            </span>
            <a
              href="#"
              onClick={handleScrollTop}
              className="w-11 h-11 flex items-center justify-center bg-white border border-gray-200 rounded-full cursor-pointer hover:bg-gray-50 transition-colors"
              title="맨 위로"
            >
              <i className="ri-arrow-up-line text-gray-600 text-lg"></i>
            </a>
          </div>
        </div>
      )}

      {/* Toggle Button */}
      <button
        onClick={() => setOpen(!open)}
        className={`w-14 h-14 flex items-center justify-center rounded-full shadow-lg cursor-pointer transition-all duration-300 ${
          open
            ? 'bg-gray-700 hover:bg-gray-800'
            : 'bg-[#03C75A] hover:bg-[#00A843]'
        }`}
        aria-label="안내 메뉴"
      >
        <i className={`${open ? 'ri-close-line' : 'ri-customer-service-2-line'} text-white text-2xl`}></i>
      </button>
    </div>
  );
}
